import loadable from "@loadable/component";
import CreateIcon from "../../../Icons/Create";
import APIS from "../../../constant/EndPoint";
import usePostHook from "../../../customHooks/usePostHook";

const CreatePaymentMethodComponent = loadable(
  () => import("../../../components/Settings/PaymentMethod/CreatePaymentMethod")
);
const CreatePaymentMethod = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["payment-method"],
    navigateURL: "/payment-method",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.PAYMENT_METHOD_TYPE}`;
    let formData = {
      ...values
     };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Payment Method</span>
      </div>
      <CreatePaymentMethodComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreatePaymentMethod;
